/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsUsers } from '../../models/profile-analytics-users';

export interface ProfileUsersDateHistogram$Params {
  id: number;
}

export function profileUsersDateHistogram(http: HttpClient, rootUrl: string, params: ProfileUsersDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsUsers>> {
  const rb = new RequestBuilder(rootUrl, profileUsersDateHistogram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileAnalyticsUsers>;
    })
  );
}

profileUsersDateHistogram.PATH = '/analytics/profile/{id}/users';
